"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var CommentThreadTypes_1 = require("@CommonFrontendBackend/Comments/Types/CommentThreadTypes");
var CommentServiceTypes_1 = require("./CommentServiceTypes");
var CommentThreadURL_1 = require("@CommonFrontendBackend/Comments/Linking/CommentThreadURL");
var CommentApiTypes_1 = require("@CommonFrontendBackend/Comments/Types/CommentApiTypes");
var CommentService = (function () {
    function CommentService(apiBaseUrl, clientUrl, projectId, blockId) {
        var _this = this;
        this.apiBaseUrl = apiBaseUrl;
        this.clientUrl = clientUrl;
        this.projectId = projectId;
        this.blockId = blockId;
        this.config = {
            withCredentials: true,
        };
        this.createCommentThread = function (commentMessage) { return __awaiter(_this, void 0, Promise, function () {
            var message, mentions, contentWithMentions, data, response, e_1, error, outcome;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        message = commentMessage.message, mentions = commentMessage.mentions, contentWithMentions = commentMessage.contentWithMentions;
                        data = {
                            projectId: this.projectId,
                            blockId: this.blockId,
                            content: message,
                            mentions: mentions,
                            contentWithMentions: contentWithMentions,
                        };
                        if (!mentions || mentions.length === 0) {
                            delete data.contentWithMentions;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.createThread(data)];
                    case 2:
                        response = _a.sent();
                        return [2, {
                                data: response.data,
                                outcome: CommentServiceTypes_1.CommentSaveOutcome.Success,
                            }];
                    case 3:
                        e_1 = _a.sent();
                        error = e_1;
                        outcome = this.mapCommentSaveErrorResponseToOutcome(error);
                        return [2, {
                                outcome: outcome,
                            }];
                    case 4: return [2];
                }
            });
        }); };
        this.getCommentThread = function (threadId) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getThread(threadId)];
                    case 1:
                        response = _a.sent();
                        return [2, this.transformThreadData(response.data)];
                }
            });
        }); };
        this.toggleCommentThreadResolved = function (threadId, resolved) { return __awaiter(_this, void 0, Promise, function () {
            var status, data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        status = resolved ? CommentThreadTypes_1.CommentThreadStatus.Resolved : CommentThreadTypes_1.CommentThreadStatus.Unresolved;
                        data = {
                            status: status,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.updateThread(threadId, data)];
                    case 2:
                        _a.sent();
                        return [2, CommentServiceTypes_1.CommentResolveOutcome.Success];
                    case 3:
                        error_1 = _a.sent();
                        return [2, this.mapCommentResolveErrorResponseToOutcome(error_1)];
                    case 4: return [2];
                }
            });
        }); };
        this.deleteCommentThread = function (threadId) { return __awaiter(_this, void 0, Promise, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.deleteThread(threadId)];
                    case 1:
                        _a.sent();
                        return [2, CommentServiceTypes_1.CommentSaveOutcome.Success];
                    case 2:
                        error_2 = _a.sent();
                        return [2, this.mapCommentDeleteErrorResponseToOutcome(error_2)];
                    case 3: return [2];
                }
            });
        }); };
        this.replyToCommentThread = function (threadId, commentMessage) { return __awaiter(_this, void 0, Promise, function () {
            var message, mentions, contentWithMentions, data, response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        message = commentMessage.message, mentions = commentMessage.mentions, contentWithMentions = commentMessage.contentWithMentions;
                        data = {
                            threadId: threadId,
                            content: message,
                            contentWithMentions: contentWithMentions,
                            mentions: mentions,
                        };
                        if (mentions.length === 0) {
                            delete data.contentWithMentions;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.createComment(data)];
                    case 2:
                        response = _a.sent();
                        return [2, {
                                data: {
                                    commentId: response.data,
                                },
                                outcome: CommentServiceTypes_1.CommentSaveOutcome.Success,
                            }];
                    case 3:
                        error_3 = _a.sent();
                        return [2, {
                                outcome: this.mapCommentSaveErrorResponseToOutcome(error_3),
                            }];
                    case 4: return [2];
                }
            });
        }); };
        this.updateCommentInThread = function (commentId, message, mentions) { return __awaiter(_this, void 0, Promise, function () {
            var data, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {
                            content: message,
                            mentions: mentions,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.updateComment(commentId, data)];
                    case 2:
                        _a.sent();
                        return [2, CommentServiceTypes_1.CommentSaveOutcome.Success];
                    case 3:
                        error_4 = _a.sent();
                        return [2, this.mapCommentSaveErrorResponseToOutcome(error_4)];
                    case 4: return [2];
                }
            });
        }); };
        this.deleteCommentInThread = function (commentId) { return __awaiter(_this, void 0, Promise, function () {
            var error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.deleteComment(commentId)];
                    case 1:
                        _a.sent();
                        return [2, CommentServiceTypes_1.CommentSaveOutcome.Success];
                    case 2:
                        error_5 = _a.sent();
                        return [2, this.mapCommentDeleteErrorResponseToOutcome(error_5)];
                    case 3: return [2];
                }
            });
        }); };
        this.getCommentThreadURL = function (threadId, source) {
            return (0, CommentThreadURL_1.getCommentThreadURL)(_this.clientUrl, _this.projectId, threadId, source);
        };
        this.createThread = function (data) {
            return axios_1.default.post("".concat(_this.apiBaseUrl, "/comment-thread"), data, _this.config);
        };
        this.getThread = function (threadId) {
            return axios_1.default.get("".concat(_this.apiBaseUrl, "/comment-thread/").concat(threadId), _this.config);
        };
        this.updateThread = function (threadId, data) {
            return axios_1.default.put("".concat(_this.apiBaseUrl, "/comment-thread/").concat(threadId), data, _this.config);
        };
        this.deleteThread = function (threadId) {
            return axios_1.default.delete("".concat(_this.apiBaseUrl, "/comment-thread/").concat(threadId), _this.config);
        };
        this.createComment = function (data) {
            return axios_1.default.post("".concat(_this.apiBaseUrl, "/comment"), data, _this.config);
        };
        this.updateComment = function (commentId, data) {
            return axios_1.default.put("".concat(_this.apiBaseUrl, "/comment/").concat(commentId), data, _this.config);
        };
        this.deleteComment = function (commentId) {
            return axios_1.default.delete("".concat(_this.apiBaseUrl, "/comment/").concat(commentId), _this.config);
        };
        this.transformThreadData = function (data) {
            var comments = data.comments.map(function (comment) {
                var parsedComment = {
                    id: comment._id,
                    message: comment.content,
                    createdAt: new Date(comment.createdAt),
                    lastEditedAt: new Date(comment.updatedAt),
                    user: comment.createdBy,
                    mentions: comment.mentions,
                };
                return parsedComment;
            });
            var user = comments.length > 0 ? comments[0].user : null;
            return {
                id: data._id,
                isRead: true,
                isResolved: data.status == CommentThreadTypes_1.CommentThreadStatus.Resolved,
                isDeleted: data.status === CommentThreadTypes_1.CommentThreadStatus.Deleted,
                comments: comments,
                user: user,
            };
        };
        this.mapCommentSaveErrorResponseToOutcome = function (axiosError) {
            var response = axiosError.response;
            if (!response) {
                return CommentServiceTypes_1.CommentSaveOutcome.NetworkError;
            }
            if (response.status === 403) {
                return CommentServiceTypes_1.CommentSaveOutcome.LoggedOut;
            }
            if (response.data.error && response.data.error.additionalInfo) {
                var additionalInfo = response.data.error.additionalInfo;
                var mappedSaveOutcome = getSaveOutcomeFromError(additionalInfo.errorKey);
                if (mappedSaveOutcome) {
                    return mappedSaveOutcome;
                }
            }
            return CommentServiceTypes_1.CommentSaveOutcome.UnknownFailure;
        };
        this.mapCommentDeleteErrorResponseToOutcome = function (axiosError) {
            var response = axiosError.response;
            if (!response) {
                return CommentServiceTypes_1.CommentSaveOutcome.NetworkError;
            }
            if (response.status === 403) {
                return CommentServiceTypes_1.CommentSaveOutcome.LoggedOut;
            }
            if (response.status === 404) {
                return CommentServiceTypes_1.CommentSaveOutcome.CommentDeleted;
            }
            if (response.data.error && response.data.error.additionalInfo) {
                var additionalInfo = response.data.error.additionalInfo;
                var mappedSaveOutcome = getSaveOutcomeFromError(additionalInfo.errorKey);
                if (mappedSaveOutcome) {
                    return mappedSaveOutcome;
                }
            }
            return CommentServiceTypes_1.CommentSaveOutcome.UnknownFailure;
        };
        this.mapCommentResolveErrorResponseToOutcome = function (axiosError) {
            var response = axiosError.response;
            if (!response) {
                return CommentServiceTypes_1.CommentResolveOutcome.NetworkError;
            }
            if (response.status === 403) {
                return CommentServiceTypes_1.CommentResolveOutcome.LoggedOut;
            }
            if (response.status === 404) {
                return CommentServiceTypes_1.CommentResolveOutcome.ThreadDeleted;
            }
            return CommentServiceTypes_1.CommentResolveOutcome.UnknownFailure;
        };
    }
    return CommentService;
}());
exports.default = CommentService;
var ApiErrorIdToCommentSaveOutcome = Object.freeze((_a = {},
    _a[CommentApiTypes_1.CommentApiErrorKey.ThreadDeleted] = CommentServiceTypes_1.CommentSaveOutcome.ThreadDeleted,
    _a[CommentApiTypes_1.CommentApiErrorKey.CommentNotFound] = CommentServiceTypes_1.CommentSaveOutcome.CommentDeleted,
    _a));
var getSaveOutcomeFromError = function (errorKey) {
    return ApiErrorIdToCommentSaveOutcome[errorKey];
};
